const apps = [
  "New Braz", "New Hybrid", "IBO Player", "Smarters Pro", "Dream TV",
  "Purple IPTV", "ISP IPTV", "VEJO V3", "XCLOUD TV", "Smart TV", "Fire Stick", "TV Box",
];

export const AppsMarquee = () => (
  <section data-testid="apps-marquee" className="py-10 border-y border-white/10 bg-[#0F0F13] overflow-hidden">
    <p className="text-center text-xs uppercase tracking-[0.3em] text-white/40 mb-6">
      Compatível com seus apps e dispositivos favoritos
    </p>
    <div className="relative flex overflow-hidden">
      <div className="animate-marquee flex shrink-0 items-center gap-12 pr-12">
        {[...apps, ...apps].map((app, i) => (
          <span
            key={i}
            className="text-lg sm:text-xl font-bold text-white/30 whitespace-nowrap hover:text-[#FF5A00] transition-colors"
            style={{ fontFamily: "Outfit, sans-serif" }}
          >
            {app}
          </span>
        ))}
      </div>
    </div>
  </section>
);
